// extracted by mini-css-extract-plugin
export default {"container":"bread_crumbs_container__1XYF2","crumbsLink":"bread_crumbs_crumbsLink__UACq7","crumbsLinkActive":"bread_crumbs_crumbsLinkActive__+gBH5"};